import React from 'react';
import { useState, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import Listing from './search/listing';

function ListingWrapper() {
    let [advertisement, setAdvertisment] = useState({});
    let [currentPage, setCurrentPage] = useState(0);
    let [filters, setFilters] = useState({});
    let [shouldRender, setShouldRender] = useState(false);
    //let [additionalData, setAdditionalData] = useState({});
    let [listOfRecords, setListOfRecords] = useState([]);

    const searchFilterChangeHandler = useCallback((e) => {
        console.log('[searchFilterChangeHandler]');
        console.log(e.detail);
        let localFilters = {};
        localFilters = e.detail.filters;
        let localAdditionalData = {};
        let localListOfRecords = [];
        localAdditionalData = e.detail.additionalData;
        localListOfRecords =
            localAdditionalData && localAdditionalData.listOfRecords
                ? localAdditionalData.listOfRecords
                : [];
        let localAdvertisement = localAdditionalData.advertisement;
        let localCurrentPage = parseFloat(e.detail.currentPage) - 1;
        console.log('[localAdvertisement]');
        console.log(localAdvertisement);
        console.log('[localCurrentPage]' + localCurrentPage);
        setFilters((filters) => ({
            ...filters,
            ...localFilters,
        }));
        setListOfRecords(() => [...localListOfRecords]);
        setAdvertisment(() => localAdvertisement);
        setCurrentPage(() => localCurrentPage);
        setShouldRender(true);
    });
    useEffect(() => {
        document.addEventListener('searchfilterchange', searchFilterChangeHandler);
        return () => {
            document.removeEventListener('searchfilterchange', searchFilterChangeHandler);
        };
    }, []);
    if (shouldRender) {
        if (listOfRecords && listOfRecords.length > 0) {
            return (
                <Listing
                    page={currentPage}
                    advertisement={advertisement}
                    recordData={listOfRecords}
                />
            );
        } else {
            return (
                <div className="row mb-3">
                    <div className="col-12">
                        <h5>No new businesses found.</h5>
                    </div>
                </div>
            );
        }
    }
    return <></>;
}
ReactDOM.render(<ListingWrapper />, document.getElementById('uiapp'));
